import React from "react";
import { useSelector } from "react-redux";

export default function SaveMessage() {
  const saveMessage = useSelector((state) => state.saveMessage);
  return (
    <div
      style={{
        position: "absolute",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10%",
        left: "0",
        right: "0",
        textAlign: "center",
        color: "#198754ec",
      }}
    >
      {saveMessage.message !== "" ? saveMessage : ""}
    </div>
  );
}
